import React from 'react'
import { IExternalGMS } from '@cbgms/api'
import { useTranslation } from 'react-i18next'
import { isRequired } from '@cbgms/base/utils/validations'
import { COUNTRYOPTIONS } from 'core/constants/countries'
import FormikFormLayout, { IDeleteOptions } from 'core/page/layout/FormikFormLayout'
import { Form, FormProps } from '@carsys/form'
import Box from '@mui/material/Box'
import { Typography } from '@mui/material'
import { TextField } from '@carsys/form/src/TextField'
import { Checkbox } from '@carsys/form/src/Checkbox'
import { CountriesDropdownFormik } from '@carsys/form/src/CountriesDropdownFormik'
import ImageUploader from 'app-support/ImageUploader/ImageUploader'
import { MediaCategory } from 'app-support/ImageUploader/media-category'

interface Props extends FormProps<IExternalGMS, IExternalGMS> {
  form: string
  headerText: string
  deleteOptions?: IDeleteOptions
}

const ExternalGMSForm: React.FC<Props> = props => {
  const { t } = useTranslation()
  const { form, headerText, deleteOptions, ...formProps } = props
  return (
    <Form formID={form} {...formProps}>
      <FormikFormLayout
        title={<Typography variant='h5'>{t(headerText)}</Typography>}
        backButtonProps={{ to: '/external-gms' }}
        deleteOptions={deleteOptions}
      >
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 auto' }}>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField
                data-testid='input-external-gms-name'
                fullWidth={false}
                sx={{ minWidth: '300px' }}
                label={t('external_gms.name')}
                name='Name'
                required
                validate={isRequired}
              />
              <CountriesDropdownFormik
                data-testid='input-external-countrycode'
                label={t('external_gms.country')}
                sx={{ minWidth: '300px' }}
                name='CountryCode'
                required
                countryOptions={COUNTRYOPTIONS}
              />
            </Box>
            <Box>
              <Checkbox data-testid='is-none' label={t('external_gms.is_none')} name='IsNone' />
              <Checkbox data-testid='has-remark' label={t('external_gms.has_remark')} name='HasRemark' />
            </Box>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 auto' }}>
            <ImageUploader name='ImageURL' category={MediaCategory.Wholesaler} />
          </Box>
        </Box>
      </FormikFormLayout>
    </Form>
  )
}

export default ExternalGMSForm
